import React, { useCallback, useEffect, useState } from 'react';
import SquareBox from 'components/SquareBox';
import Lib from 'library';
import { Link, useNavigate } from 'react-router-dom';
import { userState, checkMyDataLinkState, myDataLinkBottomLayerState } from 'states';
import { useRecoilValue, useSetRecoilState } from 'recoil';

const LevelTabPane = ({ type, children, title, preSelectedTabIndex }) => {
    const navigate = useNavigate();
    const user = useRecoilValue(userState) // 유저
    const [subTabList, setSubTabList] = useState();
    const [selectedTabIndex, setSelectedTabIndex] = useState(preSelectedTabIndex || 0);
    const [selectedTabType, setSelectedTabType] = useState();
    const [levelData, setLevelData] = useState();

    const checkMyDataLink = useRecoilValue(checkMyDataLinkState) // 마데 연동 중 상태값
	const setMyDataLinkBottomLayer = useSetRecoilState(myDataLinkBottomLayerState) // my data 연동 중 화면 진입, 또는 API 호출을 막았을 때 노출되는 bottom layer state

    const getSubTabList = () => {
        Lib.get(`api/comm/cd/${type}`, data => setSubTabList(data));
    };

    const getLevelData = (subType = null) => {
        console.log("TODO 레벨 데이터 가져오기");

        let params = {
            type: type,
            subType: subType
        };

        console.log(params);

        // setLevelData({
        //     min: 0,                         // 1 레벨 기준 값
        //     max: 2606294827,                // 100 레벨 기준 값
        //     level: "10"                     // 내 레벨
        // });

        // Lib.get(`api/my/main/level?`, data => setSubTabList(data));

        let url = "api/my/main/level?mainTab=" + type;
        
        if (subType) {
            url += "&subTab=" + subType;
        }

        Lib.get(url, data => setLevelData(data));

        // switch(type) {
        //     case "bank":
        //         setLevelData({
        //             min: 0,                         // 1 레벨 기준 값
        //             max: 999999,                // 100 레벨 기준 값
        //             level: "10"                     // 내 레벨
        //         });
        //         break;
        //     case "card":
        //         setLevelData();                     // 먼저, 데이터 연결을 한 후 비교 분석을 해보세요.
        //         break;
        //     case "irp":
        //         setLevelData({
        //             min: 0,                         // 1 레벨 기준 값
        //             max: 204647145,                // 100 레벨 기준 값
        //             level: "20"                     // 내 레벨
        //         });
        //         break;
        //     case "insurance":
        //         setLevelData({
        //             min: 0,                         // 1 레벨 기준 값
        //             max: 1995074718,                // 100 레벨 기준 값
        //             level: "68"                     // 내 레벨
        //         });
        //         break;
        //     case "credit":
                
        //         break;
        //     default:
        //         setLevelData();
        //         break;
        // }
        
    }

    const onHandleClick = (e) => {
        console.log(e.currentTarget.dataset.type);
        if (selectedTabIndex !== parseInt(e.currentTarget.dataset.index)) {
            setSelectedTabIndex(parseInt(e.currentTarget.dataset.index));
            setSelectedTabType(e.currentTarget.dataset.type);
            getLevelData(e.currentTarget.dataset.type);
        }
    }

    const onClickLevelDetail = () => {
        console.log(type, selectedTabType);
        switch(type) {
            case "ML_BANK":
                switch(selectedTabType) {
                    case "ACCOUNT":
                        // 계좌
                        navigate("/mydata/bankCompareAccount");
                        break;
                    case "INVEST":
                        // 투자
                        navigate("/mydata/bankInvest");
                        break;
                    case "LOAN":
                        // 대출
                        navigate("/mydata/bankLoan");
                        break;
                }
                break;
            case "ML_CARD":
                switch(selectedTabType) {
                    case "CARD":
                        // 카드
                        navigate("/mydata/cardCompareCard");
                        break;
                    case "LOAN":
                        // 대출
                        navigate("/mydata/cardCompareLoan");
                        break;
                }
                break;
            case "ML_INVEST":
                navigate("/mydata/stockCompare");
                break;
            case "ML_INSU":
                switch(selectedTabType) {
                    case "INSU":
                        // 보험
                        navigate("/mydata/insuranceCompareInsurance");
                        break;
                    case "loan":
                        // 대출
                        navigate("/mydata/insuranceCompareLoan");
                        break;
                }
                break;
            case "ML_EFIN":
                navigate("/mydata/efinanceCompare");
                break;
            case "ML_TELECOM":
                navigate("/mydata/communicationCompare");
                break;
            case "ML_IRP":
                navigate("/mydata/irpCompare");
                break;
            case "ML_CRDT":
                switch(selectedTabType) {
                    case "SCORE":
                        // 신용점수
                        navigate("/mydata/creditCompareScore");
                        break;
                    case "CARD":
                        // 카드
                        navigate("/mydata/creditCompareCard");
                        break;
                    case "LOAN":
                        // 대출
                        navigate("/mydata/creditCompareLoan");
                        break;
                    case "OVRD":
                        // 연체
                        navigate("/mydata/creditCompareOverdue");
                        break;
                    case "AGRMN":
                        // 보증
                        navigate("/mydata/creditCompareGuarantee");
                        break;
                }
                break;
            default:
                setLevelData();
                break;
        }
        console.log(type, selectedTabType);
    
    };

    const onClickLinkHandler = () => {
        // 마데2.0 진입 방지 추가
        if(checkMyDataLink === false){
            setMyDataLinkBottomLayer(true)
        }else{
            switch(type) {
                case "ML_BANK":
                    navigate("/data", { state: {preIndstCd:"BANK"} });
                    break;
                case "ML_CARD":
                    navigate("/data", { state: {preIndstCd:"CARD"} });
                    break;
                case "ML_INVEST":
                    navigate("/data", { state: {preIndstCd:"INVEST"} });
                    break;
                case "ML_INSU":
                    navigate("/data", { state: {preIndstCd:"INSU"} });
                    break;
                case "ML_EFIN":
                    navigate("/data", { state: {preIndstCd:"EFIN"} });
                    break;
                case "ML_TELECOM":
                    navigate("/data", { state: {preIndstCd:"TELECOM"} });
                    break;
                case "ML_IRP":
                    // 개인 IRP는 데이터 연결하기 페이지에 항목이 없음. => 은행으로
                    navigate("/data", { state: {preIndstCd:"BANK"} });
                    break;
                case "ML_CRDT":
                    navigate("/mydata/creditIntro");
                    break;
            }
        }
    }

    useEffect(() => {
        if (subTabList && subTabList.length > 0) {
            // SubTab이 없는 경우도 있기 때문에 있을 때만 동작하도록.
            setSelectedTabType(subTabList[selectedTabIndex].commCd);
            getLevelData(subTabList[selectedTabIndex].commCd);
        } else if (subTabList && subTabList.length === 0) {
            // 조회를 해왔지만 SubTab이 없는 경우.
            getLevelData();
        }
    }, [subTabList]);

    useEffect(() => {
        // 상위 탭이 변경되었을 때, 
        setSelectedTabIndex(0);
        setSelectedTabType();
        getSubTabList();
    }, [type]);

    useEffect(() => {
        // 초기에 한번
        getSubTabList();
    }, []);

    return (
        <div role="tabpanel">
            <div className="cmm-tab-btn" role="tablist">
                {
                    subTabList && subTabList.map((item, index) => (
                        <button type="button" key={index} data-type={item.commCd} data-index={index} role="tab" aria-selected={index === selectedTabIndex} onClick={onHandleClick}><span># {item.commNm}</span></button>
                    ))
                }
            </div>
            <SquareBox>
                {
                    levelData
                    ? levelData.linkUpFlag
                        ? <>
                            <div className="top">
                                <p className="cmm-txt">나의 {title} {selectedTabType && <em>{subTabList[selectedTabIndex].commNm}</em>} 레벨</p>
                                <p className="cmm-tit">Lv. <span>{levelData && levelData.lvl}</span></p>
                                <button className="icon-next-l" onClick={onClickLevelDetail}><span className="btn-icon">더보기</span></button>
                            </div>
                            <div className="figure-bar level">
                                <div className="bar">
                                    <div className="gage" data-level={levelData && String(levelData.lvl).padStart(2, '0')}>
                                        <i className="img"></i>
                                    </div>
                                    <div className="inner">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                                <span className="unit">
                                    <em>0</em>
                                    <em>{levelData && levelData.maxValue >= 1000000 ? Lib.numberToKorean(Math.round(levelData.maxValue / 1000000) * 1000000) : Lib.numberToKorean(levelData.maxValue)}{type === "ML_CRDT" && selectedTabType === "SCORE" ? "점" : "원"}</em>
                                </span>
                            </div>
                        </>
                        : <div className="data-none m_16">
                            <p>연결된 자산이 없어요.<br/>{user.mbNm}님의 자산을 추가해주세요.</p>
                            <button className="btn-base-blue" onClick={onClickLinkHandler}><span>자산연결</span></button>
                        </div>
                    : null
                }
            </SquareBox>
        </div>
    )
}

export default LevelTabPane

